/**
 * Mapplic Plugin - Entry Point
 * Bundles all modules and initializes the plugin
 */

import { NwzMapplic } from './NwzMapplic';

// Make Mapplic available globally
// window.Mapplic = Mapplic;

// Auto-initialize on elements with mapplic-id prefix
document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll<HTMLElement>('[id^=mapplic-id]');
	elements.forEach(element => {
		new NwzMapplic(element);
	});
});
